import React from 'react';
import AuthLayout from '../common/AuthLayout';
import EmailVerification from './EmailVerification';

const EmailVerificationPage = ({ onNavigate, email, token, status }) => {
  return (
    <AuthLayout
      title="Verify your email"
      subtitle="We've sent you a verification link"
    >
      <EmailVerification onNavigate={onNavigate} email={email} token={token} status={status} />
    </AuthLayout>
  );
};

export default EmailVerificationPage;
